import { useRoutes } from 'react-router-dom';

import { TopBarLayout, TSLErrorBoundary } from '@thirdspacelearning/library';
import { useKeycloakAuth } from '@tsl-frontend/tsl-keycloak-auth';

import { NavigationBar } from '@shared';
import { routes } from '@routes';

function App() {
    const { user } = useKeycloakAuth();

    const appRoutes = useRoutes(routes);

    return (
        <TopBarLayout header={<NavigationBar user={user} />}>
            <TSLErrorBoundary rollbarAccessToken="32e42a9fe8be422bb6cc04f6ddbf3706">
                {appRoutes}
            </TSLErrorBoundary>
        </TopBarLayout>
    );
}

export default App;
